import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import React, { Component } from "react";

const styles = {
  card: {
    minWidth: 275
  },
  bullet: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(0.8)"
  },
  title: {
    fontSize: 14
  },
  pos: {
    marginBottom: 12
  },
  section: {
    color: "#005458",
    fontWeight: "bold",
    paddingTop: 10,
    paddingBottom: 10,
    textDecoration: "underline"
  },
  listContainer: {
    color: "rgba(0, 0, 0, 0.87)",
    fontSize: "0.875rem",
    fontFamily: "Noto Sans",
    fontWeight: "400",
    lineHeight: "1.5"
  }
};

class TermsAndConditions extends Component {
  state = {};

  componentWillMount() {
    window.scrollTo(0, 0);
  }

  render() {
    const { classes } = this.props;
    return (
      <Card className={classes.card}>
        <CardContent>
          <Typography variant="h5" component="h2">
            SAAS SUBSCRIPTION TERMS AND CONDITIONS(“TERMS”){" "}
          </Typography>{" "}
          <Typography
            style={{ marginLeft: 0 }}
            className={classes.pos}
            color="textSecondary"
          >
            Last Updated: September 10, 2019{" "}
          </Typography>{" "}
          <Typography variant="h7" className={classes.section} component="h5">
            1. Services
          </Typography>
          <Typography variant="body2" component="p">
            <b> 1.1 Services. </b> During the Subscription Term and subject to
            these Terms(including payment of fees and the restrictions and scope
            of rights set forth herein), NTRAC hereby grants Subscriber a non -
            exclusive, nontransferable and non - sublicensable right, solely for
            the Permitted Use only by Subscriber’ s Registered Users, as ordered
            and confirmed, and paid for, by Subscriber in its online
            subscription sign - up, to access and use the Services and the NTRAC
            Materials authorized by NTRAC, 24 hours per day, seven days per week
            every day of the year, except for:
          </Typography>{" "}
          <ul
            className={classes.listContainer}
            style={{ listStyleType: "lower-alpha" }}
          >
            <li> Scheduled Downtime in accordance with Section 4.1; </li>{" "}
            <li>
              {" "}
              Service downtime or degradation due to a Force Majeure Event;{" "}
            </li>{" "}
            <li>
              {" "}
              any other circumstances beyond NTRAC 's reasonable control,
              including Subscriber 's or any Registered User' s use of Third
              Party Materials, misuse of the Services, or use of the Services
              other than in strict compliance with Subscriber’ s online
              subscription sign - up and these Terms; and{" "}
            </li>{" "}
            <li>
              {" "}
              any suspension or termination of Subscriber 's or any Registered
              Users ' access to or use of the Services as permitted by
              Subscriber’ s online subscription sign - up and these Terms.{" "}
            </li>{" "}
          </ul>
          <Typography variant="body2" component="p">
            Nothing in these Terms obligates NTRAC to deliver or make available
            any copies of the software or other technology utilized to provide
            the Services to Subscriber.Completion of the online subscription
            sign - up constitutes acceptance of, and agreement with, these terms
            and conditions{" "}
          </Typography>
          <br></br>
          <Typography variant="body2" component="p">
            <b> 1.2 System Control. </b> Subscriber acknowledges that NTRAC may
            utilize regulators and other license enforcement mechanisms to
            prevent operation of the software outside the bounds authorized
            hereunder and Subscriber agrees not to attempt to defeat or
            circumvent any such encryption, security, or license enforcement
            mechanisms.Subscriber acknowledges that it is responsible for the
            security of its own hardware and software systems used to access the
            NTRAC Systems.{" "}
          </Typography>
          <br></br>
          <Typography variant="body2" component="p">
            <b> 1.3 Service Management. </b> Subscriber will be responsible for
            designating an administrator(“ <b> User Administrator </b>”) who
            shall be responsible for (i) notifying NTRAC of each Registered User
            for which it wishes to have access to the Services; (ii) identifying
            whether the Registered User will have full access admin privileges
            or limited farm employee access; and(iii) facilitating Subscriber’ s
            review of usage logs and other auditing information provided by
            NTRAC, if applicable.Subscriber acknowledges that NTRAC is entitled
            to limit the number of Registered Users using the Services to the
            number, if any, so specified in the Subscriber’ s online
            subscription sign - up.Registered Users shall each be an
            individually named employee or contractor of Subscriber with a
            unique email address.{" "}
          </Typography>
          <br></br>
          <Typography variant="body2" component="p">
            <b> 1.4 Portable Printers. </b> Portable printers for use in the
            field may be purchased through NTRAC.All portable printers are
            direct shipped by a third - party manufacturer.Subscriber agrees
            that NTRAC makes no representation or warranty as to the portable
            printers, and Subscriber agrees to look solely to the third - party
            manufacturer under its applicable product warranty for any and all
            claims relating to the portable printers.{" "}
          </Typography>
          <br></br>
          <Typography variant="body2" component="p">
            <b> 1.5 Changes. </b> NTRAC reserves the right, in its sole
            discretion, to make any changes to the Services and the NTRAC
            Materials that it deems necessary or useful to: (a) maintain or
            enhance (i) the quality or delivery of NTRAC's services to its
            customers, (ii) the competitive strength of or market for NTRAC's
            services or (iii) the Services' cost efficiency or performance; or
            (b) to comply with applicable Law. NTRAC further reserves the right
            to alter the NTRAC Systems for the purpose of implementing user
            priorities, implementing rules for use by Subscribers, and/or
            discontinuing certain functional aspects of the NTRAC Systems. NTRAC
            may limit access during system maintenance and the operation of the
            NTRAC Systems may be interrupted due to maintenance, updates, or
            system or network failures. NTRAC may also add, withdraw, or alter
            any of the data elements or databases contained within the NTRAC
            System or the services provided through the NTRAC System. NTRAC will
            do its best to notify Subscriber no less than seven (7) days in
            advance of any major NTRAC Systems update.
          </Typography>
          <br></br>
          <Typography variant="body2" component="p">
            <b> 1.6 Subcontractors. </b> NTRAC may from time to time in its
            discretion engage third parties to perform Services (each, a
            <b>“Subcontractor”</b>).
          </Typography>
          <br></br>
          <Typography variant="h7" className={classes.section} component="h5">
            2. Subscriber Restrictions.
          </Typography>
          <Typography variant="body2" component="p">
            <b> 2.1 Reservation of Rights. </b> Nothing in these Terms grants
            any right, title or interest in or to (including any license under)
            any Intellectual Property Rights in or relating to, the Services,
            the NTRAC Materials or Third Party Materials, whether expressly, by
            implication, estoppel or otherwise. All right, title and interest in
            and to the Services, the NTRAC Materials and the Third Party
            Materials are and will remain with NTRAC and the respective rights
            holders in the Third Party Materials
          </Typography>
          <b></b>
          <Typography variant="body2" component="p">
            <b> 2.2 Authorization Limitations and Restrictions. </b> Subscriber
            shall not, and shall not permit any other Person to, access or use
            the Services or NTRAC Materials except as expressly permitted by
            these Terms and, in the case of Third Party Materials, the
            applicable third-party license agreement. For purposes of clarity
            and without limiting the generality of the foregoing, Subscriber
            shall not, except as these Terms expressly permit:
          </Typography>
          <ol
            className={classes.listContainer}
            style={{ listStyleType: "lower-alpha" }}
          >
            <li>
              {" "}
              copy, modify or create derivative works or improvements of the
              Services or any of the NTRAC Materials;{" "}
            </li>{" "}
            <li>
              {" "}
              rent, lease, lend, sell, sublicense, assign, distribute, publish,
              transfer or otherwise make available any Services or NTRAC
              Materials to any Person, including on or in connection with the
              internet or any time-sharing, service bureau, software as a
              service, cloud or other technology or service;
            </li>{" "}
            <li>
              {" "}
              reverse engineer, disassemble, decompile, decode, adapt or
              otherwise attempt to derive or gain access to the source code of
              the Services or NTRAC Materials, in whole or in part;
            </li>{" "}
            <li>
              {" "}
              bypass or breach any security device or protection used by the
              Services or NTRAC Materials or access or use the Services or NTRAC
              Materials other than by an Registered User through the use of his
              or her own then valid Access Credentials;
            </li>
            <li>
              {" "}
              input, upload, transmit or otherwise provide to or through the
              Services or NTRAC Systems, any information or materials that are
              unlawful or injurious, or contain, transmit or activate any
              Harmful Code;
            </li>
            <li>
              {" "}
              damage, destroy, disrupt, disable, impair, interfere with or
              otherwise impede or harm in any manner the Services, NTRAC
              Systems, the NTRAC Materials or NTRAC's provision of services to
              any third party, in whole or in part;
            </li>
            <li>
              {" "}
              remove, delete, alter or obscure any trademarks, Specifications,
              Documentation, EULA, warranties or disclaimers, or any copyright,
              trademark, patent or other intellectual property or proprietary
              rights notices from any Services or NTRAC Materials, including any
              copy thereof;
            </li>
            <li>
              {" "}
              access or use the Services or NTRAC Materials in any manner or for
              any purpose that infringes, misappropriates or otherwise violates
              any Intellectual Property Right or other right of any third party
              (including by any unauthorized access to, misappropriation, use,
              alteration, destruction or disclosure of the data of any other
              NTRAC customer), or that violates any applicable Law;
            </li>
            <li>
              {" "}
              access or use the Services or NTRAC Materials for purposes of
              competitive analysis of the Services or NTRAC Materials, the
              development, provision or use of a competing software service or
              product or any other purpose that is to NTRAC's detriment or
              commercial disadvantage; or
            </li>
            <li>
              {" "}
              access or use the Services or NTRAC Materials in, or in
              association with, the design, construction, maintenance, operation
              of any hazardous environments, systems or applications, any safety
              response systems or other safety-critical applications, or any
              other use or application in which the use or failure of the
              Services could lead to personal injury or severe physical or
              property damage; or
            </li>
            <li>
              {" "}
              otherwise access or use the Services or NTRAC Materials beyond the
              scope of the authorization granted under <b>Section 1.1. </b>
            </li>
          </ol>
          <Typography variant="h7" className={classes.section} component="h5">
            3. Subscriber Obligations.
          </Typography>
          <br></br>
          <Typography variant="body2" component="p">
            <b> 3.1 Subscriber Systems and Cooperation. </b> Subscriber shall at
            all times during the Term: (a) set up, maintain and operate in good
            repair and in accordance with the NTRAC Materials all Subscriber
            Systems on or through which the Services are accessed or used; (b)
            provide NTRAC Personnel with such access to Subscriber Systems as is
            necessary for NTRAC to provide the Services in accordance with the
            Agreement; and (c) provide all cooperation and assistance as NTRAC
            may reasonably request to enable NTRAC to exercise its rights and
            perform its obligations under and in connection with.
          </Typography>
          <br></br>
          <Typography variant="body2" component="p">
            <b> 3.2 Protection against Unauthorized Use. </b> Subscriber will
            use reasonable efforts to prevent unauthorized use of the NTRAC
            Materials and immediately notify NTRAC of any unauthorized use that
            comes to its attention. Without limiting the foregoing, Subscriber
            will require each Registered User to keep its user ID and password
            for the NTRAC Materials confidential and not disclose either to any
            other person. If Subscriber or any Registered User learns or
            reasonably suspects that any of its passwords has been disclosed or
            otherwise made known to any person other than an Registered User or
            if any previously Registered User ceases to be an employee or
            contractor of Subscriber, Subscriber will immediately notify NTRAC
            and promptly confirm such notice by email to NTRAC. Upon receiving
            notice of a disclosed password, NTRAC will assign a new password to
            Subscriber or Registered User as the case may be. Subscriber shall
            remain primarily liable for any act or error of, or breach of these
            Terms by, a Registered User. Subscriber agrees to defend, indemnify
            and hold NTRAC and its licensees and licensors harmless for all
            damage, losses, costs, expenses (including reasonable attorney’s
            fees) and liabilities resulting from the unauthorized use of
            Subscriber’s or any Registered User’s user identification numbers or
            passwords
          </Typography>
          <br></br>
          <Typography variant="body2" component="p">
            <b> 3.3 Effect of Subscriber Failure or Delay. </b> NTRAC is not
            responsible or liable for any delay or failure of performance caused
            in whole or in part by Subscriber's delay in performing, or failure
            to perform, any of its obligations under these Terms (each, a “
            <b>Subscriber Failure</b>”).
          </Typography>
          <br></br>
          <Typography variant="body2" component="p">
            <b> 3.4 Corrective Action and Notice. </b> If Subscriber becomes
            aware of any actual or threatened activity prohibited by{" "}
            <b>Section 2.2</b> or <b>Section 3.2</b>, Subscriber shall, and
            shall cause its Registered Users to, immediately: (a) take all
            reasonable and lawful measures within their respective control that
            are necessary to stop the activity or threatened activity and to
            mitigate its effects (including, where applicable, by discontinuing
            and preventing any unauthorized access to the Services and NTRAC
            Materials and permanently erasing from their systems and destroying
            any data to which any of them have gained unauthorized access); and
            (b) notify NTRAC of any such actual or threatened activity.
          </Typography>
          <br></br>
          <Typography variant="h7" className={classes.section} component="h5">
            4. Service Availability.
          </Typography>
          <Typography variant="body2" component="p">
            The availability and function levels of the NTRAC Service shall be
            as specified in NTRAC’s online package descriptions. NTRAC's sole
            obligation and liability and Subscriber's sole remedy for any
            Service failure shall be as specified in the online packages.
          </Typography>
          <br></br>
          <Typography variant="body2" component="p">
            <b> 4.1. Scheduled Downtime. </b> NTRAC will use commercially
            reasonable efforts to give Subscriber at least 24 hours prior notice
            of all scheduled outages of the Services (“<b>Scheduled Downtime</b>
            ”).
          </Typography>
          <br></br>
          <Typography variant="body2" component="p">
            <b> 4.2. Service Support. </b> The Services include NTRAC’s standard
            customer support services (“<b>Support Services</b>”) as specified
            in NTRAC’s online package descriptions. Subscriber may purchase
            enhanced support services separately at NTRAC’s then current rates.
          </Typography>
          <Typography variant="h7" className={classes.section} component="h5">
            5. Data Backup.
          </Typography>
          <Typography variant="body2" component="p">
            The NTRAC Systems are programmed to perform routine data backups. In
            the event of any loss, destruction, damage or corruption of
            Subscriber Data caused by the NTRAC Systems or Services, NTRAC will,
            as its sole obligation and liability and as Subscriber's sole
            remedy, use commercially reasonable efforts to restore the
            Subscriber Data from NTRAC's then most current backup of such
            Subscriber Data in accordance with the then current Backup Policy.
          </Typography>
          <Typography variant="h7" className={classes.section} component="h5">
            6. Security.
          </Typography>
          <Typography variant="body2" component="p">
            <b> 6.1 NTRAC Systems and Security Obligations. </b> NTRAC will
            employ security measures in accordance with NTRAC's data privacy and
            security policy as amended from time to time.
          </Typography>
          <br></br>
          <Typography variant="body2" component="p">
            <b> 6.2 Data Breach Procedures. </b> NTRAC maintains a data breach
            plan in accordance with the criteria set forth in NTRAC's Privacy
            and Security Policy and shall implement the procedures required
            under such data breach plan on the occurrence of a “Data Breach” (as
            defined in such plan).
          </Typography>
          <br></br>
          <Typography variant="body2" component="p">
            <b> 6.3 Subscriber Control and Responsibility. </b> Subscriber has
            and will retain sole responsibility for: (a) all Subscriber Data,
            including its content and use; (b) all information, instructions and
            materials provided by or on behalf of Subscriber or any Registered
            User in connection with the Services; (c) Subscriber's information
            technology infrastructure, including computers, software, databases,
            electronic systems (including database management systems) and
            networks, whether operated directly by Subscriber or through the use
            of third-party services (“<b>Subscriber Systems</b>”). Subscriber
            shall employ all physical, administrative and technical controls,
            screening and security procedures and other safeguards necessary to
            control the content and use of Subscriber Data, including the
            uploading or other provision of Subscriber Data for Processing by
            the Services.
          </Typography>
          <Typography variant="h7" className={classes.section} component="h5">
            7. Fees; Payment Terms.
          </Typography>
          <Typography variant="body2" component="p">
            <b> 7.1 Fees. </b> Subscriber shall pay NTRAC the fees set forth in
            the Subscriber’s online subscription sign-up, utilizing NTRAC’s
            online payment service.
          </Typography>
          <br></br>
          <Typography variant="body2" component="p">
            <b> 7.2 Taxes </b> All Fees and other amounts payable by Subscriber
            under these Terms are exclusive of taxes and similar assessments.
            Subscriber is responsible for all sales, use and excise taxes, and
            any other similar taxes, duties and charges of any kind imposed by
            any federal, state or local governmental or regulatory authority on
            any amounts payable by Subscriber hereunder, other than any taxes
            imposed on NTRAC's income.
          </Typography>
          <br></br>
          <Typography variant="body2" component="p">
            <b> 7.3 Payment. </b> Subscriber shall pay all Fees as and in the
            manner specified in the Subscriber’s online subscription sign-up
            utilizing NTRAC’s online payment service. Payment obligations are
            non-cancelable and fees paid are non-refundable except as otherwise
            explicitly described herein.
          </Typography>
          <br></br>
          <Typography variant="body2" component="p">
            <b> 7.4 Late Payment. </b> If Subscriber fails to make any payment
            when due then, in addition to all other remedies that may be
            available:
          </Typography>
          <br></br>
          <ol
            className={classes.listContainer}
            style={{ listStyleType: "lower-alpha" }}
          >
            <li>
              NTRAC may charge interest on the past due amount at the rate of
              1.5% per month calculated daily and compounded monthly or, if
              lower, the highest rate permitted under applicable Law;
            </li>
            <li>
              Subscriber shall reimburse NTRAC for all costs incurred by NTRAC
              in collecting any late payments or interest, including reasonable
              attorneys' fees, court costs and collection agency fees; and
            </li>
            <li>
              if such failure continues for 10 days following written notice
              thereof, NTRAC may suspend performance of the Services until all
              past due amounts and interest thereon have been paid, without
              incurring any obligation or liability to Subscriber or any other
              Person by reason of such suspension.
            </li>
            <li>
              any suspension or termination of Subscriber 's or any Registered
              Users ' access to or use of the Services as permitted by
              Subscriber’ s online subscription sign - up and these Terms.
            </li>
          </ol>
          <br></br>
          <Typography variant="body2" component="p">
            <b> 7.5 No Deductions or Setoffs. </b> All amounts payable to NTRAC
            under these Terms shall be paid by Subscriber to NTRAC in full
            without any setoff, recoupment, counterclaim, deduction, debit or
            withholding for any reason (other than any deduction or withholding
            of tax as may be required by applicable Law).
          </Typography>
          <Typography variant="h7" className={classes.section} component="h5">
            8. Intellectual Property Rights.
          </Typography>
          <Typography variant="body2" component="p">
            <b> 8.1 Services and NTRAC Materials. </b> All right, title and
            interest in and to the Services and NTRAC Materials, including all
            Intellectual Property Rights therein, are and will remain with NTRAC
            and the respective rights holders in the Third Party Materials.
            Subscriber has no right, license or authorization with respect to
            any of the Services or NTRAC Materials (including Third Party
            Materials). All other rights in and to the Services and NTRAC
            Materials (including Third Party Materials) are expressly reserved
            by NTRAC and the respective thirdparty licensors. In furtherance of
            the foregoing, Subscriber hereby unconditionally and irrevocably
            grants to NTRAC an assignment of all right, title and interest in
            and to the Resultant Data, including all Intellectual Property
            Rights relating thereto.
          </Typography>
          <br></br>
          <Typography variant="body2" component="p">
            <b> 8.2 Subscriber Data. </b> As between Subscriber and NTRAC,
            Subscriber is and will remain the sole and exclusive owner of all
            right, title and interest in and to all Subscriber Data, including
            all Intellectual Property Rights relating thereto, subject to the
            rights and permissions, if applicable, granted in <b>Section 8.3</b>
            .
          </Typography>
          <br></br>
          <Typography variant="body2" component="p">
            <b> 8.3 Consent to Sharing of Certain Subscriber Data. </b> The
            performance of the Services and the NTRAC Materials may be enhanced
            by the sharing of certain Subscriber Data and other subscribers’
            data through the NTRAC materials. Subscriber hereby authorizes NTRAC
            to collect and share Subscriber Data through the NTRAC Materials in
            a manner that does not identify any such data as belonging to
            Subscriber by combining Subscriber Data in anonymized data sets. If
            Subscriber does not desire to participate in such data sharing,
            Subscriber shall utilize the online opt-out which shall void the
            provisions of this <b>Section 8.3</b>. Subscriber shall further have
            the right to opt-out of such data sharing at any time in the future
            by exercising such right online, and upon receipt thereof, or upon
            the expiration or any earlier termination of these Terms, NTRAC
            shall use commercially reasonable efforts to terminate such data
            sharing expeditiously; provided, that NTRAC will not be obligated to
            remove any Subscriber Data that (i) was shared prior to the
            cessation of such data sharing and (ii) cannot be reasonably removed
            from the NTRAC Materials. Subscriber expressly acknowledges and
            agrees that if it opts out of such data sharing, it will not be
            permitted to participate in any data sharing by other NTRAC
            subscribers and will not have access to certain data and
            functionality in the NTRAC Systems that are based upon or use such
            data sharing by other NTRAC subscribers.
          </Typography>
          <br></br>
          <Typography variant="h7" className={classes.section} component="h5">
            9. Confidentiality
          </Typography>
          <Typography variant="body2" component="p">
            <b> 9.1 Confidential Information. </b> In connection with these
            Terms each party (as the “<b>Disclosing Party</b>”) may disclose or
            make available Confidential Information to the other party (as the “
            <b>Receiving Party</b>”). Subject to <b>Section 9.2</b>, “
            <b>Confidential Information</b>” means information in any form or
            medium (whether oral, written, electronic or other) that the
            Disclosing Party considers confidential or proprietary, including
            information consisting of or relating to the Disclosing Party’s
            technology, trade secrets, know-how, business operations, plans,
            strategies, customers, and pricing, and information with respect to
            which the Disclosing Party has contractual or other confidentiality
            obligations, in each case whether or not marked, designated or
            otherwise identified as “confidential”. Without limiting the
            foregoing, all NTRAC Materials are the Confidential Information of
            NTRAC and the terms of these Terms are Confidential Information of
            NTRAC.
          </Typography>
          <br></br>
          <Typography variant="body2" component="p">
            <b> 9.2 Exclusions. </b> Confidential Information does not include
            information that: (a) was rightfully known to the Receiving Party
            without restriction on use or disclosure prior to such information's
            being disclosed or made available to the Receiving Party in
            connection with these Terms; (b) was or becomes generally known by
            the public other than by the Receiving Party's or any of its
            Representatives' noncompliance with these Terms; (c) was or is
            received by the Receiving Party on a non-confidential basis from a
            third party that, to the Receiving Party's knowledge, was not or is
            not, at the time of such receipt, under any obligation to maintain
            its confidentiality; or (d) the Receiving Party can demonstrate by
            written or other documentary records was or is independently
            developed by the Receiving Party without reference to or use of any
            Confidential Information.
          </Typography>
          <br></br>
          <Typography variant="body2" component="p">
            <b> 9.3 Protection of Confidential Information. </b> As a condition
            to being provided with any disclosure of or access to Confidential
            Information, the Receiving Party shall:
          </Typography>
          <ol
            className={classes.listContainer}
            style={{ listStyleType: "lower-alpha" }}
          >
            <li>
              not access or use Confidential Information other than as necessary
              to exercise its rights or perform its obligations under and in
              accordance with these Terms;
            </li>
            <li>
              except as may be permitted by and subject to its compliance with{" "}
              <b>Section 9.4</b>, not disclose or permit access to Confidential
              Information other than to its Representatives who: (i) need to
              know such Confidential Information for purposes of the Receiving
              Party's exercise of its rights or performance of its obligations
              under and in accordance with these Terms; (ii) have been informed
              of the confidential nature of the Confidential Information and the
              Receiving Party's obligations under this Section 9.3; and (iii)
              are bound by written confidentiality and restricted use
              obligations at least as protective of the Confidential Information
              as the terms set forth in this <b>Section 9.3</b>;
            </li>
            <li>
              safeguard the Confidential Information from unauthorized use,
              access or disclosure using at least the degree of care it uses to
              protect its similarly sensitive information and in no event less
              than a reasonable degree of care; and
            </li>
            <li>
              ensure its Representatives' compliance with, and be responsible
              and liable for any of its Representatives' non-compliance with,
              the terms of this <b>Section 9</b>.
            </li>
          </ol>
          <Typography variant="body2" component="p">
            <b> 9.4 Compelled Disclosures. </b> If the Receiving Party or any of
            its Representatives is compelled by applicable Law to disclose any
            Confidential Information then, to the extent permitted by applicable
            Law, the Receiving Party shall: (a) if legally permissible,
            promptly, and prior to such disclosure, notify the Disclosing Party
            in writing of such requirement so that the Disclosing Party can seek
            a protective order or other remedy or waive its rights under{" "}
            <b>Section 9.3</b>; and (b) provide reasonable assistance to the
            Disclosing Party, at the Disclosing Party's sole cost and expense,
            in opposing such disclosure or seeking a protective order or other
            limitations on disclosure. If the Disclosing Party waives compliance
            or, after providing the notice and assistance required under this
            <b>Section 9.4</b>, the Receiving Party remains required by Law to
            disclose any Confidential Information, the Receiving Party shall
            disclose only that portion of the Confidential Information that the
            Receiving Party is legally required to disclose and, on the
            Disclosing Party's request, shall use commercially reasonable
            efforts to obtain assurances from the applicable court or other
            presiding authority that such Confidentia l Information will be
            afforded confidential treatment.
          </Typography>
          <Typography variant="h7" className={classes.section} component="h5">
            10. Term and Termination.
          </Typography>
          <Typography variant="body2" component="p">
            <b> 10.1 Term. </b> The term of Subscriber’s subscription commences
            as of the Effective Date, and shall continue for the Subscription
            Term specified in the Subscriber’s online subscription sign-up (the
            “<b>Initial Term</b> Subscriber’s subscription may be renewed by
            Subscriber online (each a “<b>Renewal Term</b>” and, collectively,
            together with the Initial Term, the “<b>Term</b>”).
          </Typography>
          <br></br>
          <Typography variant="body2" component="p">
            <b> 10.2 Termination. </b> In addition to any other express
            termination right set forth elsewhere in these Terms:
          </Typography>
          <ol
            className={classes.listContainer}
            style={{ listStyleType: "lower-alpha" }}
          >
            <li>
              NTRAC may terminate Subscriber’s subscription, effective on
              written notice to Subscriber, if Subscriber: (i) fails to pay any
              amount when due hereunder, and such failure continues more than
              fifteen (15) days after NTRAC's delivery of written notice
              thereof; or (ii) breaches any of its obligations under
              <b>Section 2.2</b> (Authorization Limitations and Restrictions),{" "}
              <b>Section 3.2</b> (Protection against Unauthorized Use) or{" "}
              <b>Section 9</b> (Confidentiality).
            </li>
            <li>
              either party may terminate Subscriber’s subscription, effective on
              written notice to the other party, if the other party materially
              breaches these Terms, and such breach: (i) is incapable of cure;
              or (ii) being capable of cure, remains uncured thirty (30) days
              after the non-breaching party provides the breaching party with
              written notice of such breach; and
            </li>
            <li>
              either party may terminate Subscriber’s subscription, effective
              immediately upon written notice to the other party, if the other
              party: (i) becomes insolvent or is generally unable to pay, or
              fails to pay, its debts as they become due; (ii) files or has
              filed against it, a petition for voluntary or involuntary
              bankruptcy or otherwise becomes subject, voluntarily or
              involuntarily, to any proceeding under any domestic or foreign
              bankruptcy or insolvency Law; (iii) makes or seeks to make a
              general assignment for the benefit of its creditors; or (iv)
              applies for or has appointed a receiver, trustee, custodian or
              similar agent appointed by order of any court of competent
              jurisdiction to take charge of or sell any material portion of its
              property or business.
            </li>
          </ol>
          <Typography variant="body2" component="p">
            <b> 10.3 Effect of Expiration or Termination. </b> Upon any
            expiration or termination of Subscriber’s subscription, except as
            expressly otherwise provided in these Terms:
          </Typography>
          <ol
            className={classes.listContainer}
            style={{ listStyleType: "lower-alpha" }}
          >
            <li>
              all rights, licenses, consents and authorizations granted by
              either party to the other hereunder will immediately terminate;
            </li>
            <li>
              NTRAC shall immediately cease all use of any Subscriber Data or
              Subscriber's Confidential Information and (i) promptly return to
              Subscriber, or at Subscriber's written request destroy, all
              documents and tangible materials containing, reflecting,
              incorporating or based on Subscriber Data or Subscriber's
              Confidential Information; and (ii) permanently erase all
              Subscriber Data and Subscriber's Confidential Information from all
              systems NTRAC directly or indirectly controls, provided that, for
              clarity, NTRAC's obligations under this <b>Section 10.3(b)</b> do
              not apply to any Resultant Data;
            </li>
            <li>
              Subscriber shall immediately cease all use of any Services or
              NTRAC Materials and (i) promptly return to NTRAC, or at NTRAC's
              written request destroy, all documents and tangible materials
              containing, reflecting, incorporating or based on any NTRAC
              Materials or NTRAC's Confidential Information; and (ii)
              permanently erase all NTRAC Materials and NTRAC's Confidential
              Information from all systems Subscriber directly or indirectly
              controls; and (iii) certify to NTRAC in a signed written
              instrument that it has complied with the requirements of this{" "}
              <b>Section 10.3(c)</b>;
            </li>
            <li>
              notwithstanding anything to the contrary in these Terms, with
              respect to information and materials then in its possession or
              control: (i) the Receiving Party may retain the Disclosing Party's
              Confidential Information; and (ii) NTRAC may retain Subscriber
              Data, in the case of each of subclause (i) and (ii) in its then
              current state and solely to the extent and for so long as required
              by applicable Law; (iii) NTRAC may also retain Subscriber Data as
              provided in Section in its backups, archives and disaster recovery
              systems until such Subscriber Data is deleted in the ordinary
              course; and (iv) all information and materials described in this{" "}
              <b>Section 10.3(d)</b> will remain subject to all confidentiality,
              security and other applicable requirements of these Terms;
            </li>
            <li>
              NTRAC may disable all Subscriber and Registered User access to the
              Services and NTRAC Materials;
            </li>
            <li>
              if Subscriber terminates Subscriber’s subscription pursuant to
              Section 10.2(b), Subscriber will be relieved of any obligation to
              pay any Fees attributable to the period after the effective date
              of such termination and NTRAC will: (i) refund to Subscriber Fees
              paid in advance for Services that NTRAC has not performed as of
              the effective date of termination; and
            </li>
            <li>
              if NTRAC terminates Subscriber’s subscription pursuant to Section
              10.2(a) or Section 10.2(b), all Fees that would have become
              payable had the Agreement remained in effect until expiration of
              the Subscription Term will become immediately due and payable, and
              Subscriber shall pay such Fees, together with all
              previously-accrued but not yet paid Fees, on receipt of NTRAC's
              invoice therefor
            </li>
          </ol>
          <Typography variant="body2" component="p">
            <b> 10.4 Surviving Terms. </b> The provisions set forth in the
            following sections, and any other right or obligation of the parties
            in these Terms that, by its nature, should survive termination or
            expiration of Subscriber’s subscription, will survive any expiration
            or termination of Subscriber’s subscription: <b>Section 3.2</b>,
            <b>Section 9</b>, <b>Section 10.3</b>, this <b>Section 10.4</b>,{" "}
            <b>Section 11</b>, <b>Section 12</b>,<b>Section 14</b> and{" "}
            <b>Section 15</b>.
          </Typography>
          <Typography variant="h7" className={classes.section} component="h5">
            11. Warranty Disclaimers.
          </Typography>
          <Typography variant="body2" component="p">
            NTRAC AND ITS LICENSORS EXPRESSLY DISCLAIM ANY AND ALL WARRANTIES,
            WHETHER EXPRESS, ORAL, IMPLIED, STATUTORY, OR OTHERWISE, INCLUDING
            ANY IMPLIED WARRANTY OF FITNESS FOR A PARTICULAR PURPOSE,
            MERCHANTABILITY, TITLE, OR NON-INFRINGEMENT, AND ANY WARRANTIES
            ARISING BY VIRTUE OF CUSTOM OF TRADE OR COURSE OF DEALING. FURTHER,
            NTRAC AND ITS LICENSORS DO NOT REPRESENT OR WARRANT THAT THE NTRAC
            SYSTEM OR ANY PART THEREOF WILL MEET SUBSCRIBER’S REQUIREMENTS OR IS
            SUITABLE FOR SUBSCRIBER’S NEEDS OR THAT THE DATA OR RESULTS PROVIDED
            IN CONJUNCTION THEREWITH ARE CORRECT, ACCURATE, TIMELY, COMPLETE,
            SUITABLE OR RELIABLE. THESE DISCLAIMERS SHALL APPLY REGARDLESS OF
            ANY FAILURE OF ESSENTIAL PURPOSE OF ANY LIMITED REMEDY. SUBSCRIBER
            ACKNOWLEDGES THAT THE INFORMATION PROVIDED THROUGH THE NTRAC SYSTEM
            IS COMPILED FROM SOURCES BEYOND THE CONTROL OF NTRAC AND THE PARTIES
            ACKNOWLEDGE THAT ERRORS, GAPS, AND INACCURACIES MAY OCCUR.
            SUBSCRIBER ACKNOWLEDGES THAT THE NTRAC SYSTEM AND PROPRIETARY DATA
            ACCESSED THEREON IS PROVIDED TO SUBSCRIBER ON AN "AS IS, WITH ALL
            FAULTS" BASIS AND WITHOUT WARRANTIES OF ANY KIND. SUBSCRIBER ASSUMES
            ALL RISK OF ERRORS AND OMISSIONS IN THE NTRAC SYSTEM AND PROPRIETARY
            DATA, INCLUDING THE TRANSMISSION OR TRANSLATION OF INFORMATION.
            SUBSCRIBER ASSUMES FULL RESPONSIBILITY FOR IMPLEMENTING SUFFICIENT
            PROCEDURES AND CHECKS TO SATISFY ITS REQUIREMENTS FOR THE ACCURACY
            AND SUITABILITY OF THE NTRAC SYSTEM, INCLUDING THE PROPRIETARY DATA,
            AND FOR MAINTAINING ANY MEANS THAT SUBSCRIBER MAY REQUIRE FOR THE
            RECONSTRUCTION OF LOST DATA OR SUBSEQUENT MANIPULATIONS OR ANALYSES
            OF THE INFORMATION PROVIDED UNDER THE AGREEMENT. THE NTRAC SYSTEM IS
            INTENDED AS A SUPPLEMENT TO, AND NOT A SUBSTITUTE FOR, THE
            KNOWLEDGE, EXPERTISE, SKILL, AND JUDGMENT OF PROFESSIONALS.
            SUBSCRIBER UNDERSTANDS THAT THE NTRAC SYSTEM IS NOT INFALLIBLE, AND
            SUBSCRIBER ACCEPTS ALL RISKS IN ITS USE OF THE NTRAC SYSTEM
            INCLUDING BUT NOT LIMITED TO ANY BUSINESS OR FINANCIAL DECISIONS
            WHICH ARE BASED IN WHOLE OR IN PART ON THE USE OF THE NTRAC SYSTEM.
          </Typography>
          <Typography variant="body2" component="p">
            <b> 11.1 Indemnification </b>
          </Typography>
          <br></br>
          <Typography variant="body2" component="p">
            <b> 11.2 NTRAC Indemnification. </b> NTRAC shall indemnify, defend
            and hold harmless Subscriber and Subscriber's officers, directors,
            employees, agents, permitted successors and permitted assigns (each,
            a “<b>Subscriber Indemnitee</b>”) from and against any and all
            Losses incurred by such Subscriber Indemnitee arising out of or
            relating to any claim, suit, action or proceeding (each, an “
            <b>Action</b>”) by a third party (other than an Affiliate of a
            Subscriber Indemnitee) alleging to the extent that such Losses arise
            from any allegation in such Action that Subscriber's use of the
            Services (excluding Subscriber Data and Third Party Materials) in
            compliance with these Terms (including the Specifications) infringes
            a U.S. Intellectual Property Right. The foregoing obligation does
            not apply to any Action or Losses arising out of or relating to any:
          </Typography>
          <ol
            className={classes.listContainer}
            style={{ listStyleType: "lower-alpha" }}
          >
            <li>
              access to or use of the Services or NTRAC Materials in combination
              with any hardware, system, software, network or other materials or
              service not provided or authorized in writing by NTRAC;
            </li>
            <li>
              modification of the Services or NTRAC Materials other than: (i) by
              or on behalf of NTRAC; or (ii) with NTRAC's written approval in
              accordance with NTRAC's written specification;
            </li>
            <li>
              failure to timely implement any modifications, upgrades,
              replacements or enhancements made available to Subscriber by or on
              behalf of NTRAC; or
            </li>
            <li>
              act, omission or other matter described in <b>Section 11.2(a)</b>,
              or <b>Section 11.2(b)</b>, whether or not the same results in any
              Action against or Losses by any NTRAC Indemnitee.
            </li>
          </ol>
          <Typography variant="body2" component="p">
            <b> 11.3 Subscriber Indemnification. </b>
            Subscriber shall indemnify, defend and hold harmless NTRAC and its
            Affiliates, and each of its and their respective officers,
            directors, employees, agents, successors and assigns (each, a “
            <b>NTRAC Indemnitee</b>”) from and against any and all Losses
            incurred by such NTRAC Indemnitee in connection with any Action by a
            third party (other than an Affiliate of a NTRAC Indemnitee) to the
            extent that such Losses arise out of or relate to any:
          </Typography>
          <ol
            className={classes.listContainer}
            style={{ listStyleType: "lower-alpha" }}
          >
            <li>
              breach by Subscriber of any Subscriber representation, covenant or
              other obligation set forth herein; or
            </li>
            <li>
              any materials or information (including any documents, data,
              specifications, software, content or technology) provided by or on
              behalf of Subscriber or any Registered User, including NTRAC's
              compliance with any specifications or directions provided by or on
              behalf of Subscriber or any Registered User to the extent prepared
              without any contribution by NTRAC
            </li>
          </ol>
          <Typography variant="body2" component="p">
            <b> 11.4 Indemnification Procedure. </b> Each party shall promptly
            notify the other party in writing of any Action for which such party
            believes it is entitled to be indemnified pursuant to{" "}
            <b>Section 11.1</b> or <b>Section 11.2</b>, as the case may be. The
            party seeking indemnification (the “<b>Indemnitee</b>”) shall
            cooperate with the other party (the “<b>Indemnitor</b>”) at the
            Indemnitor's sole cost and expense. The Indemnitor shall immediately
            take control of the defense and investigation of such Action and
            shall employ counsel of its choice reasonably acceptable to the
            Indemnitee to handle and defend the same, at the Indemnitor's sole
            cost and expense. The Indemnitee's failure to perform any
            obligations under this <b>Section 11.4</b> will not relieve the
            Indemnitor of its obligations under this
            <b>Section 11</b> except to the extent that the Indemnitor can
            demonstrate that it has been prejudiced as a result of such failure.
            The Indemnitee may participate in and observe the proceedings at its
            own cost and expense with counsel of its own choosing.
          </Typography>
          <br></br>
          <Typography variant="body2" component="p">
            <b> 11.5 Mitigation. </b> If any of the Services or NTRAC Materials
            are, or in NTRAC's opinion are likely to be, claimed to infringe,
            misappropriate or otherwise violate any third-party Intellectual
            Property Right, or if Subscriber's or any Registered User's use of
            the Services or NTRAC Materials is enjoined or threatened to be
            enjoined, NTRAC may, at its option and sole cost and expense:
          </Typography>
          <ol
            className={classes.listContainer}
            style={{ listStyleType: "lower-alpha" }}
          >
            <li>
              obtain the right for Subscriber to continue to use the Services
              and NTRAC Materials materially as contemplated by these Terms;
            </li>
            <li>
              modify or replace the Services and NTRAC Materials, in whole or in
              part, to seek to make the Services and NTRAC Materials (as so
              modified or replaced) non-infringing, while providing materially
              equivalent features and functionality, in which case such
              modifications or replacements will constitute Services and NTRAC
              Materials, as applicable, under these Terms; or
            </li>
            <li>
              by written notice to Subscriber, terminate Subscriber’s
              subscription with respect to all or part of the Services and NTRAC
              Materials, and require Subscriber to immediately cease any use of
              the Services and NTRAC Materials or any specified part or feature
              thereof.
            </li>
          </ol>
          <Typography variant="body2" component="p">
            THIS SECTION 11 SETS FORTH CUSTOMER'S SOLE REMEDIES AND NTRAC'S SOLE
            LIABILITY AND OBLIGATION FOR ANY ACTUAL, THREATENED OR ALLEGED
            CLAIMS THAT SUBSCRIBER’S SUBSCRIPTION OR ANY SUBJECT MATTER HEREOF
            (INCLUDING THE SERVICES AND NTRAC MATERIALS) INFRINGES,
            MISAPPROPRIATES OR OTHERWISE VIOLATES ANY THIRD PARTY INTELLECTUAL
            PROPERTY RIGHT.
          </Typography>
          <Typography variant="h7" className={classes.section} component="h5">
            12. Limitations of Liability.
          </Typography>
          <Typography variant="body2" component="p">
            <b> 12.1 EXCLUSION OF DAMAGES </b> EXCEPT AS PROVIDED HEREIN, IN NO
            EVENT WILL NTRAC OR ANY OF ITS LICENSORS, SUBCONTRACTORS OR
            SUPPLIERS BE LIABLE UNDER OR IN CONNECTION WITH SUBSCRIBER’S
            SUBSCRIPTION, OR THESE TERMS OR THEIR SUBJECT MATTER, UNDER ANY
            LEGAL OR EQUITABLE THEORY, INCLUDING BREACH OF CONTRACT, TORT
            (INCLUDING NEGLIGENCE), STRICT LIABILITY AND OTHERWISE, FOR ANY:
            LOST PROFITS, BUSINESS, OR REVENUE, CONSEQUENTIAL, INCIDENTAL,
            INDIRECT, EXEMPLARY, SPECIAL, ENHANCED OR PUNITIVE DAMAGES,
            REGARDLESS OF WHETHER SUCH PERSONS WERE ADVISED OF THE POSSIBILITY
            OF SUCH LOSSES OR DAMAGES OR SUCH LOSSES OR DAMAGES WERE OTHERWISE
            FORESEEABLE, AND NOTWITHSTANDING THE FAILURE OF ANY AGREED OR OTHER
            REMEDY OF ITS ESSENTIAL PURPOSE. THE FOREGOING EXCLUSION OF DAMAGES
            SHALL NOT APPLY TO ANY LOSSES OR DAMAGES ATTRIBUTABLE TO (i) NTRAC’S
            WILLFUL MISCONDUCT OR GROSS NEGLIGENCE, OR (ii) NTRAC’S FAILURE TO
            COMPLY WITH THE CONFIDENTIALITY OBLIGATIONS IMPOSED ON IT PURSUANT
            TO SECTION 10, ABOVE
          </Typography>
          <Typography variant="body2" component="p">
            <b> 12.2 CAP ON MONETARY LIABILITY. </b> EXCEPT AS PROVIDED HEREIN,
            IN NO EVENT WILL THE COLLECTIVE AGGREGATE LIABILITY OF NTRAC AND ITS
            LICENSORS, SUBCONTRACTORS AND SUPPLIERS UNDER OR IN CONNECTION WITH
            SUBSCRIBER’S SUBSCRIPTION, OR THESE TERMS OR THEIR SUBJECT MATTER,
            UNDER ANY LEGAL OR EQUITABLE THEORY, INCLUDING BREACH OF CONTRACT,
            TORT (INCLUDING NEGLIGENCE), STRICT LIABILITY AND OTHERWISE, EXCEED
            THE AGGREGATE FEES PAID BY CUSTOMER TO NTRAC FOR THE TWELVE MONTHS
            IMMEDIATELY PRECEDING SUCH CLAIM. THE FOREGOING LIMITATION APPLIES
            NOTWITHSTANDING THE FAILURE OF ANY AGREED OR OTHER REMEDY OF ITS
            ESSENTIAL PURPOSE. THE FOREGOING CAP ON MONETARY LIABILITY SHALL NOT
            APPLY TO ANY LOSSES OR DAMAGES ATTRIBUTABLE TO (i) NTRAC’S WILLFUL
            MISCONDUCT OR GROSS NEGLIGENCE OR(ii) NTRAC’S FAILURE TO COMPLY WITH
            THE CONFIDENTIALITY OBLIGATIONS IMPOSED ON IT PURSUANT TO SECTION
            10, ABOVE.
          </Typography>
          <Typography variant="h7" className={classes.section} component="h5">
            13. Force Majeure.
          </Typography>
          <Typography variant="body2" component="p">
            <b> 13.1 No Breach or Default </b> In no event will NTRAC be liable
            or responsible to Subscriber, or be deemed to have defaulted under
            or breached Subscriber’s subscription, for any failure or delay in
            fulfilling or performing any term or obligation, when and to the
            extent such failure or delay is caused by any circumstances beyond
            NTRAC's reasonable control (a “<b>Force Majeure Event</b>”),
            including acts of God, flood, fire, earthquake or explosion, war,
            terrorism, invasion, riot or other civil unrest, embargoes or
            blockades in effect on or after the date of Subscriber’s
            subscription, national or regional emergency, strikes, labor
            stoppages or slowdowns or other industrial disturbances, passage of
            Law or any action taken by a governmental or public authority,
            including imposing an embargo, export or import restriction, quota
            or other restriction or prohibition or any complete or partial
            government shutdown, or national or regional shortage of adequate
            power or telecommunications or transportation. Either party may
            terminate Subscriber’s subscription if a Force Majeure Event
            continues substantially uninterrupted for a period of 60 days or
            more. In the event of any failure or delay caused by a Force Majeure
            Event, NTRAC shall give prompt written notice to Subscriber stating
            the period of time the occurrence is expected to continue and use
            commercially reasonable efforts to end the failure or delay and
            minimize the effects of such Force Majeure Event
          </Typography>
          <Typography variant="h7" className={classes.section} component="h5">
            14. Definitions.
          </Typography>
          <Typography variant="body2" component="p">
            Certain capitalized terms used herein shall have the respective
            meanings set forth below:
          </Typography>
          <Typography variant="body2" component="p">
            <b> “Access Credentials” </b> ” means any user name, identification
            number, password, license or security key, security token, PIN or
            other security code, method, technology or device used, alone or in
            combination, to verify an individual's identity and authorization to
            access and use the Services.
          </Typography>
          <br></br>
          <Typography variant="body2" component="p">
            <b> "Affiliate" </b> ” of a Person means any other Person that
            directly or indirectly, through one or more intermediaries,
            controls, is controlled by, or is under common control with, such
            Person.
          </Typography>
          <br></br>
          <Typography variant="body2" component="p">
            <b> “Registered User” </b> ” ” means each of the individuals
            authorized to use the Services pursuant to <b>Section 1.3</b> of
            these Terms.
          </Typography>
          <br></br>
          <Typography variant="body2" component="p">
            <b> “Subscriber Data” </b> ” means, other than Resultant Data,
            information, data and other content, in any form or medium that is
            collected, downloaded or otherwise received, directly or indirectly
            from Subscriber or an Registered User by or through the Services.
          </Typography>
          <br></br>
          <Typography variant="body2" component="p">
            <b> “Subscriber Systems” </b> means the Subscriber's information
            technology infrastructure, including computers, software, hardware,
            databases, electronic systems (including database management
            systems) and networks, whether operated directly by Subscriber or
            through the use of third-party services.
          </Typography>
          <br></br>
          <Typography variant="body2" component="p">
            <b> “Documentation” </b> means any manuals, instructions or other
            documents or materials that NTRAC provides or makes available to
            Subscriber in any form or medium and which describe the
            functionality, components, features or requirements of the Services
            or the NTRAC Materials, including any aspect of the installation,
            configuration, integration, operation, use, support or maintenance
            thereof
          </Typography>
          <br></br>
          <Typography variant="body2" component="p">
            <b> “Harmful Code” </b>means any software, hardware or other
            technology, device or means, including any virus, worm, malware or
            other malicious computer code, the purpose or effect of which is to
            (a) permit unauthorized access to, or to destroy, disrupt, disable,
            distort, or otherwise harm or impede in any manner any (i) computer,
            software, firmware, hardware, system or network or (ii) any
            application or function of any of the foregoing or the security,
            integrity, confidentiality or use of any data Processed thereby, or
            (b) prevent Subscriber or any Registered User from accessing or
            using the Services or the NTRAC Materials as intended by these
            Terms.
          </Typography>
          <br></br>
          <Typography variant="body2" component="p">
            <b>“Intellectual Property Rights” </b> ” means any and all
            registered and unregistered rights granted, applied for or otherwise
            now or hereafter in existence under or related to any patent,
            copyright, trademark, trade secret, database protection or other
            intellectual property rights laws, and all similar or equivalent
            rights or forms of protection, in any part of the world, including
            without limitation (i) patents, patent applications, patent
            disclosures and inventions (whether patentable or not), (ii)
            trademarks, service marks, trade dress, trade names, logos,
            corporate names, Internet domain names, and registrations and
            applications for the registration thereof together with all of the
            goodwill associated therewith, (iii) copyrights and copyrightable
            works (including computer programs and mask works) and registrations
            and applications thereof, (iv) trade secrets, know-how and other
            confidential information, and (v) rights of publicity or moral
            rights.
          </Typography>
          <br></br>
          <Typography variant="body2" component="p">
            <b>“Internal Use” </b> means ordinary use by Subscriber for its own
            internal business purposes. For avoidance of doubt, Internal Use
            does not include any of the activities described in Section 3 below.
          </Typography>
          <br></br>
          <Typography variant="body2" component="p">
            <b>“Law” </b> ” means any statute, law, ordinance, regulation, rule,
            code, order, constitution, treaty, common law, judgment, decree or
            other requirement of any federal, state, local or foreign government
            or political subdivision thereof, or any arbitrator, court or
            tribunal of competent jurisdiction.
          </Typography>
          <br></br>
          <Typography variant="body2" component="p">
            <b>“Losses” </b> means any and all losses, damages, liabilities,
            deficiencies, claims, actions, judgments, settlements, interest,
            awards, penalties, fines, costs or expenses of whatever kind,
            including reasonable attorneys' fees and the costs of enforcing any
            right to indemnification hereunder and the cost of pursuing any
            insurance providers
          </Typography>
          <br></br>
          <Typography variant="body2" component="p">
            <b> “NTRAC Materials” </b>means the NTRAC Systems and Documentation
            and any and all other information, data, documents, materials, works
            and other content, devices, methods, processes, hardware, software
            and other technologies and inventions, including any deliverables,
            technical or functional descriptions, requirements, plans or
            reports, that are provided or used by NTRAC or any Subcontractor in
            connection with the Services or otherwise comprise or relate to the
            Services or NTRAC Systems. For the avoidance of doubt, NTRAC
            Materials include Resultant Data and any information, data or other
            content derived from NTRAC's monitoring of Subscriber's access to or
            use of the Services, but do not include Subscriber Data.
          </Typography>
          <br></br>
          <Typography variant="body2" component="p">
            <b> “NTRAC Personnel” </b> means all individuals involved in the
            performance of Services as employees, agents or independent
            contractors of NTRAC or any Subcontractor.
          </Typography>
          <br></br>
          <Typography variant="body2" component="p">
            <b> “NTRAC Systems” </b>means the information technology
            infrastructure used by or on behalf of NTRAC in performing the
            Services, including all computers, software (including the Service
            Software), hardware, databases, electronic systems (including
            database management systems) and networks, whether operated directly
            by NTRAC or through the use of third-party services.
          </Typography>
          <br></br>
          <Typography variant="body2" component="p">
            <b> “Permitted Use” </b> means any use of the Services by an
            Registered User for the benefit of Subscriber solely in or for
            Subscriber's Internal Use.
          </Typography>
          <br></br>
          <Typography variant="body2" component="p">
            <b> “Person” </b> means an individual, corporation, partnership,
            joint venture, limited liability entity, governmental authority,
            unincorporated organization, trust, association or other entity.
          </Typography>
          <br></br>
          <Typography variant="body2" component="p">
            <b> “Process” </b> means to take any action or perform any operation
            or set of operations that the Services are capable of taking or
            performing on any data, information or other content. “
            <b>Processing</b>” and “<b>Processed</b>” have correlative meanings.
          </Typography>
          <br></br>
          <Typography variant="body2" component="p">
            <b> “Representatives” </b> means, with respect to a party, that
            party's and its Affiliates' employees, officers, directors,
            consultants, agents, independent contractors, sublicensees,
            subcontractors and legal advisors.
          </Typography>
          <br></br>
          <Typography variant="body2" component="p">
            <b> “Resultant Data” </b> ” means information, data and other
            content that is derived by or through the Services from Processing
            Subscriber Data and is sufficiently different from such Subscriber
            Data that such Subscriber Data cannot be reverse engineered or
            otherwise identified from the inspection, analysis or further
            Processing of such information, data or content
          </Typography>
          <br></br>
          <Typography variant="body2" component="p">
            <b> “Service Software” </b> means the NTRAC software application or
            applications and any third-party or other software, and all new
            versions, updates, revisions, improvements and modifications of the
            foregoing, that NTRAC provides remote access to and use of as part
            of the Services.
          </Typography>
          <br></br>
          <Typography variant="body2" component="p">
            <b> “Subscription Term” </b> means the period of time that
            Subscriber and its Registered Users are permitted to access and use
            the Services as identified in the Subscriber’s online subscription
            sign-up.
          </Typography>
          <br></br>
          <Typography variant="body2" component="p">
            <b> “Third Party Materials” </b> ” means materials and information,
            in any form or medium, including any software, documents, data,
            content, specifications, products, equipment or components of or
            relating to the Services that are not proprietary to NTRAC.
          </Typography>
          <Typography variant="h7" className={classes.section} component="h5">
            15. Miscellaneous
          </Typography>
          
          <Typography variant="body2" component="p">
            <b> 15.1 Relationship of the Parties </b> The relationship between
            the parties is that of independent contractors. Nothing contained in
            these Terms shall be construed as creating any agency, partnership,
            joint venture or other form of joint enterprise, employment or
            fiduciary relationship between the parties, and neither party shall
            have
          </Typography>
          <br></br>
          <Typography variant="body2" component="p">
            <b> 15.2 Public Announcements. </b> Neither party shall issue or
            release any announcement, statement, press release or other
            publicity or marketing materials relating to Subscriber’s
            subscription or otherwise use the other party's trademarks, service
            marks, trade names, logos, domain names or other indicia of source,
            affiliation or sponsorship, in each case, without the prior written
            consent of the other party, which consent shall not be unreasonably
            withheld, conditioned or delayed.
          </Typography>
          <br></br>
          <Typography variant="body2" component="p">
            <b> 15.3 Notices. </b> All notices, requests, consents, claims,
            demands, waivers and other communications under these Terms have
            binding legal effect only if in writing and addressed to a party at
            the addresses set forth on the Subscriber’s online subscription
            sign-up (or to such other address or such other person that such
            party may designate from time to time in accordance with this{" "}
            <b>Section 15.3</b>. Notices sent in accordance with this{" "}
            <b>Section 15.3</b> will be deemed effectively given: (a) when
            received, if delivered by hand, with signed confirmation of receipt;
            (b) when received, if sent by a nationally recognized overnight
            courier, signature required; (c) when sent, if by e-mail, (in each
            case, with confirmation of transmission), if sent during the
            addressee's normal business hours, and on the next business day, if
            sent after the addressee's normal business hours; and (d) on the
            fifth day after the date mailed by certified or registered mail,
            return receipt requested, postage prepaid.
          </Typography>
          <br></br>
          <Typography variant="body2" component="p">
            <b> 15.4 Interpretation. </b> The parties intend these Terms shall
            be construed without regard to any presumption or rule requiring
            construction or interpretation against the party drafting an
            instrument or causing any instrument to be drafted.
          </Typography>
          <br></br>
          <Typography variant="body2" component="p">
            <b> 15.5 Entire Agreement. </b> T These Terms and any other
            documents incorporated herein by reference, constitute the sole and
            entire agreement of the parties with respect to the subject matter
            of these Terms and supersedes all prior and contemporaneous
            understandings, agreements, representations and warranties, both
            written and oral, with respect to such subject matter.
          </Typography>
          <br></br>
          <Typography variant="body2" component="p">
            <b> 15.6 Assignment. </b> Subscriber shall not assign or otherwise
            transfer any of its rights, or delegate or otherwise transfer any of
            its obligations or performance, under Subscriber’s subscription
            and/or these Terms, in each case whether voluntarily, involuntarily,
            by operation of law or otherwise, without NTRAC's prior written
            consent. For purposes of the preceding sentence, and without
            limiting its generality, any merger, consolidation or reorganization
            involving Subscriber (regardless of whether Subscriber is a
            surviving or disappearing entity) will be deemed to be a transfer of
            rights, obligations or performance under these Terms for which
            NTRAC's prior written consent is required. No delegation or other
            transfer will relieve Subscriber of any of its obligations or
            performance under these Terms. Any purported assignment, delegation
            or transfer in violation of this <b>Section 15.7</b> is void. These
            Terms are binding upon and inure to the benefit of the parties
            hereto and their respective permitted successors and assigns.
          </Typography>
          <br></br>
          <Typography variant="body2" component="p">
            <b> 15.7 No Third-party Beneficiaries </b> These Terms are for the
            sole benefit of the parties hereto and their respective permitted
            successors and permitted assigns and nothing herein, express or
            implied, is intended to or shall confer upon any other Person any
            legal or equitable right, benefit or remedy of any nature whatsoever
            under or by reason of these Terms.
          </Typography>
          <br></br>
          <Typography variant="body2" component="p">
            <b> 15.8 Amendment and Modification; Waiver. </b> No amendment to or
            modification of these Terms is effective unless it is in writing and
            signed by an authorized representative of each party. No waiver by
            any party of any of the provisions hereof shall be effective unless
            explicitly set forth in writing and signed by the party so waiving.
          </Typography>
          <br></br>
          <Typography variant="body2" component="p">
            <b> 15.9 Severability. </b> If any provision of these Terms is
            invalid, illegal or unenforceable in any jurisdiction, such
            invalidity, illegality or unenforceability shall not affect any
            other term or provision of these Terms or invalidate or render
            unenforceable such term or provision in any other jurisdiction. Upon
            such determination that any term or other provision is invalid,
            illegal or unenforceable, the parties hereto shall negotiate in good
            faith to modify such terms so as to affect the original intent of
            the parties as closely as possible in a mutually acceptable manner
            in order that the transactions contemplated hereby be consummated as
            originally contemplated to the greatest extent possible.
          </Typography>
          <br></br>
          <Typography variant="body2" component="p">
            <b> 15.10 Governing Law; Submission to Jurisdiction </b> These Terms
            are governed by and construed in accordance with the internal laws
            of the Commonwealth of Massachusetts without giving effect to any
            choice or conflict of law provision or rule that would require or
            permit the application of the laws of any jurisdiction other than
            those of the Commonwealth of Massachusetts. Any legal suit, action
            or proceeding arising out of or related to Subscriber’s
            subscription, these Terms or the licenses granted hereunder shall be
            instituted exclusively in the federal courts of the United States or
            the courts of the Commonwealth of Massachusetts in each case located
            in Boston, Massachusetts, and each party irrevocably submits to the
            exclusive jurisdiction of such courts in any such suit, action or
            proceeding.
          </Typography>
    
        </CardContent>
      </Card>
    );
  }
}

export default withStyles(styles)(TermsAndConditions);



// WEBPACK FOOTER //
// ./src/components/public/TermsAndConditions.js